import { useEffect } from 'react';
import './ClassificationSummary.scss';
import { useAppDispatch, useAppSelector } from '../../../../hooks/storeHooks';
import { fetchRodpumpclassification, selectClassificationSummary, selectWellSummaryLoading } from '../../WellSummaryDashboardSlice';
import Helpers from '../../../../utilities/Helpers';
import Loader from '../../../common/Loader/Loader';
import EmptyState from '../../../../components/empty-state/EmptyState';

const ClassificationSummary: React.FC = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(selectClassificationSummary);
  const isLoading = useAppSelector(selectWellSummaryLoading);
  useEffect(() => {
    dispatch(fetchRodpumpclassification({}));
  }, [dispatch]);
  return (
    <div className='classification-summary-container'>
      <div className='classification-summary-header'>
        <div className='header-content'>
          <h3 className='header-title'>
            <span className='header-title-full'>Rod lift classification summary</span>
            <span className='header-title-short'>Classification summary</span>
          </h3>
        </div>
        <div className='wsw-divider' />
      </div>
      {isLoading ? (
        <div className='rlcs-empty-loader'>
          <Loader />
        </div>
      ) : data.length === 0 ? (
        <div className='rlcs-empty-loader'>
          <EmptyState message='No rod lift classification data available' />
        </div>
      ) : (
        <div className='classification-summary-table-container'>
          <table className='classification-table'>
               <tbody>
                {data.map((item) => (
              <tr key={item.title}>
                <td className='name'>{Helpers.toSentenceCase(item.title)}</td>
                <td className='count'>{item.count}</td>
              </tr>
            ))}
          </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
export default ClassificationSummary;
